import { render, staticRenderFns } from "./CommonWorkCreation.vue?vue&type=template&id=6fe3d3b8&scoped=true"
import script from "./CommonWorkCreation.vue?vue&type=script&lang=js"
export * from "./CommonWorkCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe3d3b8",
  null
  
)

export default component.exports